class LyleLogoButton extends HTMLElement {
  #abortController = null;

  connectedCallback() {
    this.#abortController?.abort();
    this.#abortController = new AbortController();

    const buttons = this.querySelectorAll(".logo-button__button");

    buttons.forEach((button) => {
      button.addEventListener(
        "mouseenter",
        () => this.#setActiveIcon(button, "two"),
        {
          signal: this.#abortController.signal,
        },
      );
      button.addEventListener(
        "mouseleave",
        () => this.#setActiveIcon(button, "one"),
        {
          signal: this.#abortController.signal,
        },
      );
      button.addEventListener(
        "focus",
        () => this.#setActiveIcon(button, "two"),
        {
          signal: this.#abortController.signal,
        },
      );
      button.addEventListener(
        "blur",
        () => this.#setActiveIcon(button, "one"),
        {
          signal: this.#abortController.signal,
        },
      );
    });
  }

  disconnectedCallback() {
    this.#abortController?.abort();
    this.#abortController = null;
  }

  #setActiveIcon(button, activeIcon) {
    const iconOne = button.querySelector(".animated-icon__icon-one");
    const iconTwo = button.querySelector(".animated-icon__icon-two");

    if (!iconOne || !iconTwo) {
      return;
    }

    iconOne.classList.toggle("active-icon", activeIcon === "one");
    iconTwo.classList.toggle("active-icon", activeIcon === "two");
  }
}

if (!customElements.get("lyle-logo-button")) {
  customElements.define("lyle-logo-button", LyleLogoButton);
}
